import React, { useState } from 'react';
import { IconInstagram, IconFacebook, IconTwitter, IconTikTok } from './Icons';

export default function Navbar({ config }) {
  const { brand: rawBrand, nav, footer } = config;
  const brand = typeof rawBrand === 'object' ? (rawBrand?.name || '') : (rawBrand || '');
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <nav className="jb-nav">
      <ul className="jb-nav__left">
        <li><a href={nav.linkStartProject}>INICIAR PROJETO</a></li>
        <li><a href={nav.linkAbout}>SOBRE NÓS</a></li>
      </ul>

      <div className="jb-nav__logo">
        {nav.logoImage && !logoFailed ? (
          <img
            src={nav.logoImage}
            alt={brand}
            style={{ height: 34 }}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className="jb-nav__logo-text">{brand}</span>
        )}
      </div>

      <ul className="jb-nav__right">
        <li><a href={nav.linkSport}>ENCONTRE SEU ESPORTE</a></li>
        <li><a href={nav.linkShop}>LOJA</a></li>
      </ul>

      <div className="jb-nav__socials">
        <a href={footer.socials.instagram} title="Instagram"><IconInstagram /></a>
        <a href={footer.socials.facebook}  title="Facebook"><IconFacebook /></a>
        <a href={footer.socials.twitter}   title="Twitter"><IconTwitter /></a>
        <a href={footer.socials.tiktok}    title="TikTok"><IconTikTok /></a>
      </div>
    </nav>
  );
}